import React, { PureComponent, createRef } from 'react';
import { connect } from 'react-redux';
import tinycolor from 'tinycolor2';
import ButtonPrint from '../buttonPrint/buttonPrint'

import { toggleModal } from '../../actions/app';

import Rate from '../rate/rate';
import { logoutGovBr } from "../../actions/authentication";

import './modal.scss';

class Modal extends PureComponent {

  state = {
    type: '',
    disabled: true,
    showModalLogout: true
  }

  constructor(props) {
    super(props);
    this.modalRateRootRef = createRef();
    this.getModal = this.getModal.bind(this);
    this.getLastMessageTime = this.getLastMessageTime.bind(this);
  }

  handleClick = (type, e) => {
    this.setState({
      ...this.state,
      disabled: false,
    })
  }

  handleClose = e => {
    this.setState({
      ...this.state,
      disabled: true,
      showModalLogout: true
    });
    this.props.toggleModal(false, '');
    this.props.modal.onClose();
  }

  handleBack = e => {
    this.setState({
      ...this.state,
      disabled: true,
      showModalLogout: true
    })
    this.props.toggleModal(false, '');
  }

  /** Mesma cardinalidade que em `Rate` (estrelas vs string). */
  getEvaluationFieldsCount() {
    const config = this.props.config;
    if (
      config.conversationRatingType === 'string' &&
      config.serviceEvaluation &&
      Array.isArray(config.serviceEvaluation.labels) &&
      config.serviceEvaluation.labels.length > 0
    ) {
      return config.serviceEvaluation.labels.length;
    }
    return config.conversationRatingLabels.length;
  }

  handleConfirm = e => {
    const qtdFields = this.getEvaluationFieldsCount();
    if (qtdFields < 1) {
      return;
    }
    const conversationId = this.props.messages[1] ? this.props.messages[1].context.conversation_id : false;
    const root = this.modalRateRootRef.current;
    const checked = root && root.querySelector('.rate-container input[type="radio"]:checked');
    const scoreRaw = checked && checked.value;
    const scoreNum = parseInt(scoreRaw, 10);
    const maxIndex = qtdFields - 1;

    const selectionValid =
      checked &&
      scoreRaw !== undefined &&
      scoreRaw !== '' &&
      !Number.isNaN(scoreNum) &&
      scoreNum >= 0 &&
      scoreNum <= maxIndex;

    const scoreToSend = selectionValid ? scoreNum : maxIndex;

    const startMessage = new Date(this.props.messages[0].date);
    const endMessage = new Date(this.getLastMessageTime());

    const form = {
      conversation_id: conversationId,
      startMessage,
      endMessage,
    }

    this.props.modal.onConfirm(form, qtdFields, String(scoreToSend));
    this.handleClose();
  }

  handleConfirmLogoutGovBr = e => {
    localStorage.removeItem('user_session');
    localStorage.removeItem('govbr_logout');
    this.props.logoutGovBr(this.props.config);
    this.setState({
      ...this.state,
      showModalLogout: false
    });
  }

  handleDontLogoutGovBr = e => {
    this.setState({
      ...this.state,
      showModalLogout: false
    });
  }

  getLastMessageTime() {
    let date = '';

    const size = this.props.messages.length;

    for (let i = size - 1; i >= 0; i--) {
      const temp = this.props.messages[i].date;
      if (temp) {
        date = temp;
        break;
      }
    }

    return date;
  }

  setBg = color => e => {
    if (!color) {
      e.currentTarget.style.color = 'black';
      e.currentTarget.style.backgroundColor = 'white';
      return false;
    }
    const color2 = color;

    let fontColor = color2.darken(20);
    fontColor = fontColor.toRgbString();
    let backColor = color2.setAlpha(0.13);
    backColor = color2.toRgbString();

    e.currentTarget.style.backgroundColor = this.props.theme === 'light' ? backColor : 'lightgray';
    e.currentTarget.style.color = this.props.theme === 'light' ? fontColor : 'black';;
  }

  getModalLogoutGovBr() {
    if (this.props.config.headerColor) {
      document.documentElement.style.setProperty('--header-color', this.props.config.headerColor);
    }
    return (
      <div className='Modal-container' onClick={this.handleClose}>
        <div className='box' onClick={e => e.stopPropagation()}>
          <div className='text textTitle'>
            O atendimento será finalizado.
          </div>
          <div className='text textTitle'>
            Ah! Lembre-se de encerrar também o Meu INSS.
          </div>
          <div className='text textTitle'>
            Deseja sair da conta gov.br na Helô?
          </div>
          <div className='action-buttons'>
            <div className='action-buttons-govbr'>
              <button
                title='Não deslogar da minha conta GovBr'
                className='notLogout'
                onClick={this.handleDontLogoutGovBr}
              >
                Não
              </button>
              <button
                title='Deslogar da minha conta GovBr'
                className='logout'
                onClick={this.handleConfirmLogoutGovBr}
              >
                Sim
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  getModalRateInteration() {
    if (this.props.config.headerColor) {
      document.documentElement.style.setProperty('--header-color', this.props.config.headerColor);
    }
    const colorHeader = getComputedStyle(document.documentElement).getPropertyValue('--header-color');
    const header = tinycolor(colorHeader);

    const color = this.props.theme === 'light' ? header.getLuminance() > 0.5 ? "#333333" : "#F1f1f1" : 'black';
    return (
      <div className='Modal-container' onClick={this.handleClose}>
        <div className='box' onClick={e => e.stopPropagation()}>
          <p className='text' style={{ whiteSpace: "pre-line" }}>
            {this.props.config.leaveChatModalMessage}
          </p>
          <div ref={this.modalRateRootRef} className="modal-rate-root">
            <Rate inline onClick={this.handleClick} />
          </div>
          <ButtonPrint config={this.props.config} />
          <div className='action-buttons'>
            <button title='Sair da janela de avaliação' className='cancel' onClick={this.handleClose}>
              Sair
            </button>
            <button
              title='Voltar para o chat'
              className='back'
              style={{ color: "black" }}
              onClick={this.handleBack}
              onMouseOver={this.setBg(header)}
              onMouseOut={this.setBg("")}
            >
              Voltar para o Chat
            </button>
            <button
              title='Enviar avaliação'
              className='send'
              disabled={this.state.disabled}
              style={{ color: color }}
              onClick={this.handleConfirm}
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    );
  }

  getModal() {
    let userSession = {}
    const user = localStorage.getItem('user_session')
    const isGovAuthEnableLogout = localStorage.getItem('govbr_logout')
    userSession =  user ? JSON.parse(user) : this.props.user

    const isLogged = Object.keys(userSession).length > 0
    const canShowModalLogout = isLogged && isGovAuthEnableLogout
    return this.state.showModalLogout && canShowModalLogout ? this.getModalLogoutGovBr() : this.getModalRateInteration()
  }

  render() {
    return this.props.modal.status ? this.getModal() : false;
  }
}

const mapStateToProps = state => ({
  config: state.config,
  modal: state.app.modal,
  messages: state.messages,
  theme: state.theme,
  user: state.authentication
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (toggle, message) => dispatch(toggleModal(toggle, message)),
  logoutGovBr: (config) => dispatch(logoutGovBr(config))
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
